export const CreditRejectReasons = {
  ACTIVE_RESET_PAYBACK_PLAN_OFFER: 'ActiveResetPaybackPlanOffer',
  BANKID_ISSUE_DATE: 'BankIDIssueDate',
  BISNODE_REJECTED: 'BisnodeRejected',
  EMPLOYMENT_STATUS: 'EmploymentStatus',
  EXCEED_NUMBER_OF_LOANS: 'ExceedNumberOfLoans',
  EXISTING_CREDIT: 'ExistingCredit',
  EXISTING_LOAN: 'ExistingLoan',
  KALP_REJECTED: 'KalpRejected',
  LANESTOPP_BLOCKED: 'LanestoppBlocked',
  OPEN_BANKING_CONTINUOUS_REJECT: 'OPEN_BANKING_CONTINUOUS_REJECT',
  OVERDUE_PAYMENTS: 'OverduePayments',
  PARTNER_REJECTED: 'PartnerRejected',
  PSD_CREDIT_CHECK: 'PsdCreditCheck',
  PSD_LOW_INCOME: 'PsdLowIncome',
  RECENT_BISNODE_CALL: 'RecentBisnodeCall',
  RECENT_OPEN_BANKING_CONTINUOUS_REJECT: 'RECENT_OPEN_BANKING_CONTINUOUS_REJECT',
  TERMINATED_AGREEMENT: 'TerminatedAgreement',
  TERMINATED_LOAN: 'TerminatedLoan',
  UC_SCORE_MISSING: 'UCScoreMissing',
  UC_SERVICE_ERROR: 'UCServiceError',
  USER_AGE: 'UserAge',
  USER_BLOCKED: 'UserBlocked',
} as const;

export type CreditRejectReason = (typeof CreditRejectReasons)[keyof typeof CreditRejectReasons];

export const LevlaRejectReasons = {
  ACTIVE_AGREEMENT_NOT_OLD_ENOUGH: 'ActiveAgreementNotOldEnough',
  DIRECT_DEBIT_MANDATE_NOT_FOUND: 'DirectDebitMandateNotFound',
  ELIGIBILITY_CHECKER_REJECTED: 'EligibilityCheckerRejected',
  INTERNAL_SCORE: 'InternalScore',
  MAX_PRODUCT: 'MaxProduct',
  ONGOING_CHARGE: 'OngoingCharge',
  OVERDUE_PAYMENTS: 'OverduePayments',
  PAYMENTS_WITH_FEES: 'PaymentsWithFees',
  RECENT_BISNODE_CALL: 'RecentBisnodeCall',
  TOO_MANY_INQUIRIES: 'TooManyInquiries',
  UC_SCORE_MISSING: 'UCScoreMissing',
  UC_SERVICE_ERROR: 'UCServiceError',
  PAYMENT_FREE_MONTH: 'PaymentFreeMonth',
} as const;

export type LevlaRejectReason = (typeof LevlaRejectReasons)[keyof typeof LevlaRejectReasons];
